import { Box, Stack, Typography } from "@mui/material";

export default function EmptyListMessage(props: {
    message: string;
    condition?: boolean;
    disablePadding?: boolean;
    action?: JSX.Element;
}) {
    if (props.condition ?? true) {
        return (
            <Box
                sx={{
                    width: "100%",
                    display: "flex",
                    justifyContent: "center",
                    my: props.disablePadding ? 0 : 4,
                }}
            >
                <Stack direction="column" spacing={4} alignItems="center">
                    <Typography color="text.secondary">
                        {props.message}
                    </Typography>

                    {props.action}
                </Stack>
            </Box>
        );
    } else {
        return <></>;
    }
}
